import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0685324e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_modal_create_app",
  ref: "createAppModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-body py-lg-10 px-lg-10 bg-white rounded shadow-sm" }
const _hoisted_3 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px\" data-v-0685324e><div class=\"stepper-nav ps-lg-10\" data-v-0685324e><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\" data-v-0685324e><div class=\"stepper-line w-40px\" data-v-0685324e></div><div class=\"stepper-icon w-40px h-40px\" data-v-0685324e><i class=\"stepper-check fas fa-check\" data-v-0685324e></i><span class=\"stepper-number\" data-v-0685324e>1</span></div><div class=\"stepper-label\" data-v-0685324e><h3 class=\"stepper-title\" data-v-0685324e>Kullanıcı Bilgileri</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-0685324e><div class=\"stepper-line w-40px\" data-v-0685324e></div><div class=\"stepper-icon w-40px h-40px\" data-v-0685324e><i class=\"stepper-check fas fa-check\" data-v-0685324e></i><span class=\"stepper-number\" data-v-0685324e>2</span></div><div class=\"stepper-label\" data-v-0685324e><h3 class=\"stepper-title\" data-v-0685324e>Getir Yemek Bilgileri</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-0685324e><div class=\"stepper-line w-40px\" data-v-0685324e></div><div class=\"stepper-icon w-40px h-40px\" data-v-0685324e><i class=\"stepper-check fas fa-check\" data-v-0685324e></i><span class=\"stepper-number\" data-v-0685324e>3</span></div><div class=\"stepper-label\" data-v-0685324e><h3 class=\"stepper-title\" data-v-0685324e>Trendyol Yemek Bilgileri</h3></div></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" data-v-0685324e><div class=\"stepper-line w-40px\" data-v-0685324e></div><div class=\"stepper-icon w-40px h-40px\" data-v-0685324e><i class=\"stepper-check fas fa-check\" data-v-0685324e></i><span class=\"stepper-number\" data-v-0685324e>4</span></div><div class=\"stepper-label\" data-v-0685324e><h3 class=\"stepper-title\" data-v-0685324e>Yemek Sepeti Bilgileri</h3></div></div></div></div>", 1)
const _hoisted_5 = { class: "flex-row-fluid py-lg-5 px-lg-15" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "w-100" }
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = { class: "alert alert-info d-flex align-items-center p-5 mb-10" }
const _hoisted_10 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "Dikkat"),
  /*#__PURE__*/_createElementVNode("h6", null, "Üyeliğinize atanan şifre, girdiğiniz telefon numarasına mesaj olarak iletilecektir.")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-3 fw-bold mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header-tablet-and-mobile-fixed" }, "Cep Telefon Numaranızı Giriniz")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-7 mb-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "alert-light" }, "(5 ile başlayıp 10 rakamdan oluşmalıdır.) ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "required" }, "Telefonunuza Gelen Şifre")
], -1))
const _hoisted_17 = { "data-kt-stepper-element": "content" }
const _hoisted_18 = { class: "w-100" }
const _hoisted_19 = { class: "alert alert-info d-flex align-items-center p-5 mb-10" }
const _hoisted_20 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-3 text-primary" }, "Dikkat"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Ürün, yorum ve opsiyon bilgilerini alabilmemiz için aşağıya Getir paneline girerken kullandığınız GetirYemek kullanıcı adı ve parolanızı girmeniz gerekir.GetirYemek giriş bilgilerinizi bilmiyorsanız şifrenizi "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://restoran.getiryemek.com/login",
      target: "_blank"
    }, "https://restoran.getiryemek.com/login"),
    /*#__PURE__*/_createTextVNode(" adresinden sıfırlayabilirsiniz. ")
  ])
], -1))
const _hoisted_22 = { class: "fv-row mb-10" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Getir Yemek E-Posta")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Şifre")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Şube Seçiniz")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = ["value", "id"]
const _hoisted_31 = ["for"]
const _hoisted_32 = { "data-kt-stepper-element": "content" }
const _hoisted_33 = { class: "w-100" }
const _hoisted_34 = { class: "alert alert-info d-flex align-items-center p-5 mb-10" }
const _hoisted_35 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-3 text-primary" }, "Dikkat"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Ürün bilgilerini alabilmemiz için aşağıya Trendyol Entegrasyon bilgilerini girmeniz gerekiyor entegrasyon bilgilerini almak için : Trendyol panelinde Hesabım altında Entegrasyon Bilgileri'ne girebilirsiniz trendyola giriş yaptıysanız direk ilgili sayfaya gitmek için "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://partner.trendyol.com/account/info?tab=integrationInformation",
      target: "_blank"
    }, "tıklayınız.")
  ])
], -1))
const _hoisted_37 = { class: "fv-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Satıcı ID")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Api Key")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Api Secret")
], -1))
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Şube Seçiniz")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = ["value", "id"]
const _hoisted_47 = ["for"]
const _hoisted_48 = { "data-kt-stepper-element": "content" }
const _hoisted_49 = { class: "w-100" }
const _hoisted_50 = { class: "alert alert-info d-flex align-items-center p-5 mb-10" }
const _hoisted_51 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-3 text-primary" }, "Dikkat"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Ürün, yorum ve opsiyon bilgilerini alabilmemiz için aşağıya Yemek Sepeti Portakal giriş bilgilerini girmeniz gerekiyor. Portakal giriş bilgilerinizi bilmiyorsanız şifrenizi "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://yemeksepeti.portal.restaurant/",
      target: "_blank"
    }, "https://yemeksepeti.portal.restaurant/"),
    /*#__PURE__*/_createTextVNode(" adresinden sıfırlayabilirsiniz. ")
  ])
], -1))
const _hoisted_53 = { class: "fv-row mb-10" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Yemeksepeti E-Posta")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Şifre")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Şube Seçiniz")
], -1))
const _hoisted_60 = ["for"]
const _hoisted_61 = ["id", "value"]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Menü Seçiniz")
], -1))
const _hoisted_64 = ["for"]
const _hoisted_65 = ["id", "value"]
const _hoisted_66 = { class: "d-flex flex-stack pt-10" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, null, -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Atla ")
const _hoisted_69 = { class: "svg-icon svg-icon-3 ms-1 me-0" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Atla ")
const _hoisted_71 = { class: "svg-icon svg-icon-3 ms-1 me-0" }
const _hoisted_72 = {
  key: 2,
  type: "submit",
  class: "btn btn-lg btn-hover-rise btn-info"
}
const _hoisted_73 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Tamamla ")
const _hoisted_75 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Lütfen Bekleyin... ")
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]
const _hoisted_80 = {
  key: 3,
  type: "submit",
  class: "btn btn-lg btn-hover-rise btn-info"
}
const _hoisted_81 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Devam Et ")
const _hoisted_83 = { class: "svg-icon svg-icon-3 ms-1 me-0" }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Lütfen Bekleyin... ")
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "form",
                novalidate: "novalidate",
                id: "kt_modal_create_app_form",
                onSubmit: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                        ]),
                        _hoisted_11
                      ]),
                      _hoisted_12,
                      _hoisted_13,
                      _createVNode(_component_Field, {
                        disabled: _ctx.hide === true,
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "phone",
                        placeholder: "5XXXXXXXXX",
                        pattern: "[5]{1}[0-9]{2}[0-9]{3}[0-9]{2}[0-9]{2}",
                        required: ""
                      }, null, 8, ["disabled"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "phone"
                      }),
                      _hoisted_14,
                      (_ctx.hide)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _createVNode(_component_Field, {
                              type: "text",
                              class: "form-control form-control-lg form-control-solid",
                              name: "password",
                              placeholder: ""
                            }),
                            _createVNode(_component_ErrorMessage, {
                              class: "fv-plugins-message-container invalid-feedback",
                              name: "password"
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                      ]),
                      _hoisted_21
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "getirusername",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "getirusername"
                      }),
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "getirpassword",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "getirpassword"
                      }),
                      _hoisted_26,
                      (_ctx.branchHideGetir)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _hoisted_28,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branchesGetir, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _hoisted_29,
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: "radio-size",
                                  size: "lg",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.branchindexGetir) = $event)),
                                  value: item.Id,
                                  id: 'gtrd' + item.Id
                                }, null, 8, _hoisted_30), [
                                  [_vModelRadio, _ctx.branchindexGetir]
                                ]),
                                _createElementVNode("label", {
                                  for: 'gtrd' + item.Id
                                }, _toDisplayString(item.Name), 9, _hoisted_31)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                      ]),
                      _hoisted_36
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "supplierId",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "supplierId"
                      }),
                      _hoisted_39,
                      _hoisted_40,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "trendyolpassword",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "trendyolpassword"
                      }),
                      _hoisted_41,
                      _hoisted_42,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "trendyolusername",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "trendyolusername"
                      }),
                      (_ctx.trendyolbuttonhidden)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _hoisted_44,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branchesTy, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _hoisted_45,
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  name: "radio-size",
                                  size: "lg",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.branchindexTy) = $event)),
                                  value: item.Id,
                                  id: 'tyd' + item.Id
                                }, null, 8, _hoisted_46), [
                                  [_vModelRadio, _ctx.branchindexTy]
                                ]),
                                _createElementVNode("label", {
                                  for: 'tyd' + item.Id
                                }, _toDisplayString(item.Name), 9, _hoisted_47)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("span", _hoisted_51, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                      ]),
                      _hoisted_52
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "yemeksepetiusername",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "yemeksepetiusername"
                      }),
                      _hoisted_55,
                      _hoisted_56,
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-lg form-control-solid",
                        name: "yemeksepetipassword",
                        placeholder: ""
                      }),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "yemeksepetipassword"
                      }),
                      _hoisted_57,
                      (_ctx.branchHideYs)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _hoisted_59,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branchesYs, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("label", {
                                  class: "radio radio-lg radio-single flex-shrink-0 mr-4",
                                  for: `branch-${index}`
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    size: "lg",
                                    id: `branch-${index}`,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedBranchIndex) = $event)),
                                    value: index
                                  }, null, 8, _hoisted_61), [
                                    [_vModelRadio, _ctx.selectedBranchIndex]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(item.Name), 1)
                                ], 8, _hoisted_60)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.yshidemenu)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _hoisted_63,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ysmenulist, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("label", {
                                  class: "radio radio-lg radio-single flex-shrink-0 mr-4",
                                  for: `branch-${index}`
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    size: "lg",
                                    id: `branch-${index}`,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ysselectedmenu) = $event)),
                                    value: item.id
                                  }, null, 8, _hoisted_65), [
                                    [_vModelRadio, _ctx.ysselectedmenu]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(item.title.tr_TR), 1)
                                ], 8, _hoisted_64)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("div", null, [
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.completeRegister(''))),
                          style: {"margin-right":"2px"},
                          class: "btn btn-lg btn-outline-primary"
                        }, [
                          _hoisted_68,
                          _createElementVNode("span", _hoisted_69, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentStepIndex !== 0 &&
                        _ctx.currentStepIndex !== _ctx.totalSteps - 1
                        )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "submit",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args))),
                          style: {"margin-right":"2px"},
                          class: "btn btn-lg btn-outline-primary"
                        }, [
                          _hoisted_70,
                          _createElementVNode("span", _hoisted_71, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentStepIndex === _ctx.totalSteps - 1)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_72, [
                          (!_ctx.pleaseWait)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("span", _hoisted_75, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.pleaseWait)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_76, _hoisted_79))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("button", _hoisted_80, [
                          (!_ctx.pleaseWait)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                                _hoisted_82,
                                _createElementVNode("span", _hoisted_83, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.pleaseWait)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_84, _hoisted_87))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ])
              ], 32)
            ])
          ], 512)
        ])
      ])
    ])
  ], 512))
}